"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationHotspot = void 0;
const three_1 = require("three");
const CSS2DRenderer_1 = require("three/examples/jsm/renderers/CSS2DRenderer");
const UiElements_1 = require("../../ui/UiElements");
class AnnotationHotspot {
    constructor(annotation) {
        this._orderNumber = annotation.orderNumber;
        this._element = this.create(annotation);
    }
    get orderNumber() { return this._orderNumber; }
    set orderNumber(orderNumber) {
        this._orderNumber = orderNumber;
        this._hotspot2DCssObject.element.textContent = orderNumber + '';
    }
    get element() {
        return this._element;
    }
    set element(element) {
        this._element = element;
    }
    /**
     * Dispose object
     */
    dispose() {
        var _a, _b;
        (_a = this._hotspot2DCssObject) === null || _a === void 0 ? void 0 : _a.element.remove();
        (_b = this._element.parent) === null || _b === void 0 ? void 0 : _b.remove(this._element);
    }
    create(annotation) {
        const hotspotDiv = this.createHotspotEl(annotation);
        const annotationPoint = new three_1.Vector3(annotation.annotationPoint.x, annotation.annotationPoint.y, annotation.annotationPoint.z);
        const css2DObject = new CSS2DRenderer_1.CSS2DObject(hotspotDiv.domEl);
        css2DObject.position.copy(annotationPoint);
        css2DObject.visible = true;
        css2DObject.renderOrder = 1;
        this._hotspot2DCssObject = css2DObject;
        const spriteMaterial = new three_1.SpriteMaterial({
            transparent: true,
            sizeAttenuation: false,
            opacity: 0
        });
        const sprite = new three_1.Sprite(spriteMaterial);
        sprite.center = new three_1.Vector2(0.5, 0.5);
        sprite.scale.set(0.03, 0.03, 0.03);
        sprite.position.copy(annotationPoint);
        sprite.position.setZ(annotationPoint.z + 0.01);
        sprite.uuid = annotation.manualId;
        sprite.userData.hotspot = true;
        const group = new three_1.Group();
        group.add(css2DObject);
        group.add(sprite);
        return group;
    }
    createHotspotEl(annotation) {
        return new UiElements_1.DivEl()
            .setClass('hotspot')
            .addAttribute('data-for-annotation', annotation.manualId)
            .addChild(new UiElements_1.SpanEl().setTextContent(annotation.orderNumber + ''));
    }
    show() {
        this._element.visible = true;
        this._hotspot2DCssObject.visible = true;
    }
    hide() {
        this._element.visible = false;
        this._hotspot2DCssObject.visible = false;
    }
    //Update position of annotationPoint
    updatePosition(annotation) {
        let annotationPoint = new three_1.Vector3(annotation.annotationPoint.x, annotation.annotationPoint.y, annotation.annotationPoint.z);
        this.element.children[0].position.copy(annotationPoint);
        this.element.children[1].position.copy(annotationPoint);
    }
}
exports.AnnotationHotspot = AnnotationHotspot;
